import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    height: '700px',
  },
  editMenu: {
    position: 'absolute',
    zIndex: 5,
    top: 10,
    left: 10,
    backgroundColor: theme.palette.background.main,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[3],
    borderRadius: 5,
    overflow: 'hidden',
    transition: 'width 0.3s, height 0.3s',
  },
  menuHeader: {
    padding: '5px 10px',
    width: '100%',
    boxSizing: 'border-box',
    '& div': {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
    },
  },
  menuContent: {
    width: 'fit-content',
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  forms: {
    maxHeight: '600px',
    maxWidth: '600px',
    overflow: 'auto',
    ...theme.mixins.scrollbar,
  },
  addMenu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '5px 10px',
    gap: 10,
  },
}));

export default useStyles;
